// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".questionType[data-v-2960ccc2]{width:100%;background:#fff;padding-top:2vw}", ""]);
// Exports
module.exports = exports;
